import { jsx as l, Fragment as _, jsxs as z } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { S as f } from "./index-DoOsnuB6.js";
import { c as y } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import { S as x } from "./Spinner-Drz3dWpe.js";
import './Button.css';const h = "_buttonBase_n764l_75", B = "_button_n764l_75", b = "_xxSmallSize_n764l_119", g = "_xSmallSize_n764l_127", p = "_smallSize_n764l_135", v = "_defaultSize_n764l_143", F = "_largeSize_n764l_149", N = "_iconSize_n764l_157", W = "_primary_n764l_166", j = "_secondary_n764l_175", V = "_tertiary_n764l_188", k = "_ghost_n764l_210", w = "_ghostBrand_n764l_211", C = "_outline_n764l_251", R = "_surface_n764l_264", q = "_isFullWidth_n764l_270", A = "_rounded_n764l_274", t = {
  buttonBase: h,
  button: B,
  xxSmallSize: b,
  xSmallSize: g,
  smallSize: p,
  defaultSize: v,
  largeSize: F,
  iconSize: N,
  primary: W,
  secondary: j,
  tertiary: V,
  ghost: k,
  ghostBrand: w,
  outline: C,
  surface: R,
  isFullWidth: q,
  rounded: A
}, D = y(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), m = c(
  ({ asChild: i = !1, className: n, disabled: e, pressed: a, ...o }, s) => {
    const r = i ? f : "button", S = a === void 0 ? void 0 : { "aria-pressed": a, "data-state": a ? "on" : "off" };
    return /* @__PURE__ */ l(
      r,
      {
        className: d(t.buttonBase, n),
        "data-cxy-name": "button-base",
        disabled: e,
        ref: s,
        ...o,
        ...S
      }
    );
  }
), E = c(
  ({ asChild: i, isLoading: n, loadingText: e, variant: a, ...o }, s) => /* @__PURE__ */ l(_, { children: n ? /* @__PURE__ */ l(u, { ...o, "aria-busy": n, disabled: n, ref: s, variant: a, children: /* @__PURE__ */ z(_, { children: [
    e || "Loading",
    /* @__PURE__ */ l(x, { size: "s", variant: a === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ l(u, { ...o, asChild: i, ref: s, variant: a }) })
), u = c(
  ({ className: i, isFullWidth: n, rounded: e, size: a, variant: o, ...s }, r) => /* @__PURE__ */ l(
    m,
    {
      className: d(
        D({ variant: o, size: a }),
        { [t.isFullWidth]: n, [t.rounded]: e },
        i
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      ref: r,
      ...s
    }
  )
);
E.displayName = "Button";
m.displayName = "ButtonBase";
export {
  E as B,
  m as a,
  D as b
};
